import type { Address, Facility, Team } from '@baseball-near-you/prisma';
import { AbstractClient } from './AbstractFetchClient';

type FacilityWithTeamAndAddress = Facility & {
  team: Team | null;
  address: Address[];
};

export class FacilityClient extends AbstractClient {
  getAllFacilities = this.get<FacilityWithTeamAndAddress[], never>('/');

  getFacility = this.get<FacilityWithTeamAndAddress, { args: { id: string } }>(
    ({ id }) => `/${id}`
  );

  createFacility = this.payloadHandler<
    Facility,
    { payload: Pick<Facility, 'name' | 'description' | 'teamId' | 'addressId'> }
  >('POST', '/');

  update = this.payloadHandler<
    FacilityWithTeamAndAddress,
    {
      args: { id: string };
      payload: Partial<Facility>;
    }
  >('PUT', ({ id }) => `/${id}`);
}
